import { toRem } from '../functions';

export default {
  list: {
    maxHeight: toRem(300),
  },
};
